

export default function createStyleMarkup(css, type) {
  var media = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var mediaAttribute = media.length > 0 ? ' media="' + media + '"' : '';

  return '<style type="text/css" data-fela-type="' + type + '"' + mediaAttribute + '>' + css + '</style>';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/createStyleTagMarkup.js
// module id = 850
// module chunks = 0